var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.954,
    height: 17.952,
    viewBox: "0 0 17.954 17.952",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_17091",
    "data-name": "Path 17091",
    d: "M14.031,9l.918.918L5.912,18.957H4.995V18.04L14.031,9m3.59-6a1,1,0,0,0-.7.289L15.1,5.114l3.74,3.74,1.825-1.825a.993.993,0,0,0,0-1.406L18.329,3.289A.979.979,0,0,0,17.621,3Zm-3.59,3.181L3,17.212v3.74H6.74L17.771,9.921l-3.74-3.74Z",
    transform: "translate(-3 -3)",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.d1a8009393d406c08e5f4a80c0cc8cf6.svg";
export { ForwardRef as ReactComponent };